import DownloadButton from './DownloadButton';
import InlineSVG from '../../icons';
import Message from '../message/Message';
import ParallaxWrapper from '../common/ParallaxWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import {Redirect} from 'react-router';
import SignUp from './SignUp';
import {generateRoutePath} from 'epic-common/src/route';
import useIsMobile from '../homeV2/hooks/isMobile';
import {useSignIn} from '../../hooks/useSignIn';

const DownloadNowHeaderBlock = ({
        data,
        mobile,
        isLoggedIn,
        isGameLaunched,
        history,
        location
    }) => {
    const {
        cta,
        signin: signinText,
        subText1,
        subText2,
        image,
        background,
        characters
    } = data;
    const isMobile = useIsMobile(mobile);
    const backgroundImage = isMobile ? background.mobileImage : background.desktopImage;
    const {launched, info} = isGameLaunched;
    const signin = useSignIn(isLoggedIn, launched ? '/download-now-thankyou' : '/beta-sign-up', history);
    const showDownload = /thankyou/.test(location.pathname);
    if (showDownload && !isLoggedIn || showDownload && !launched) {
        return (
            <Redirect to={generateRoutePath('/download-now')} />
        )
    }
    return (
        <section className="downloadnow header-block" style={{backgroundImage: `url(${backgroundImage})`}}>
            <div className="container-fluid section">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <div className="characters">
                            {characters.length > 0 ? (
                                    <>
                                    <ParallaxWrapper toRoot kill={isMobile} className="spy-parallax" speed={35}>
                                        <div className="spy" style={{backgroundImage: `url(${characters[1].desktopImage})`}} />
                                    </ParallaxWrapper>
                                    <ParallaxWrapper toRoot kill={isMobile} className="leader-parallax" speed={20}>
                                        <div className="leader" style={{backgroundImage: `url(${characters[0].desktopImage})`}} />
                                    </ParallaxWrapper>
                                    </>
                            ) : null} 
                            {isMobile && image ? (<div className="mobile-characters" style={{backgroundImage: `url(${image.mobileImage})`}} />) : null}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <div className="content text-center">
                            <div className="logos-section">
                                <div className="icons">
                                    <i className="icon-eg" />
                                    <i className="icon-badRobot" />
                                </div>
                                <h6><Message code="epic.common.presents" /></h6>
                            </div>
                            <h1>
                                <InlineSVG name="logo" className="logo" />
                            </h1>
                            {!isLoggedIn && <h2 className="blue">{signinText}</h2>}
                            {isLoggedIn && subText1 && <h2 className="blue">{subText1}</h2>}
                            {isLoggedIn && subText2 && <h3 className="white">{subText2}</h3>}
                            {!launched && <SignUp returnUrl="/beta-sign-up" ctaString={cta} />}
                            {launched && !showDownload && <SignUp returnUrl="/download-now-thankyou" ctaString={cta} />}
                            {isLoggedIn && launched && showDownload && <DownloadButton info={info} />}
                            {!isLoggedIn && <h5 className="hidden-xs hidden-sm">
                                <Message code="epic.spyjinx.downloadnow.alreadyhaveaccount" />
                                &nbsp;<span className="signin" role="button" tabIndex="-1" onClick={signin}><Message code="epic.spyjinx.downloadnow.signin" /></span>
                            </h5>}
                        </div>
                    </div>
                </div>
            </div>
            <InlineSVG name="slant" className="diagonal-clip" />
        </section>
    );
};
DownloadNowHeaderBlock.propTypes = {
    data: PropTypes.object,
    mobile: PropTypes.bool,
    isSubscribed: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    history: PropTypes.object,
    appImage: PropTypes.string,
    isGameLaunched: PropTypes.object,
    downloadLink: PropTypes.string,
    location: PropTypes.object
}

export default DownloadNowHeaderBlock;
